import { callAPi, callAPiMultiPart } from "./api";

const create = (data) => callAPiMultiPart.post("/admin/tribute", data);
const edit = (data, id) => callAPiMultiPart.patch(`/admin/tribute/${id}`, data);
const get = () => callAPi.get("/tributes");
const getByID = (id) => callAPi.get(`/tributes/${id}`);
const getArchived = () => callAPi.get("/admin/tributes/archived");
const archiveTribute = (id) => callAPi.patch(`/admin/tribute/${id}/archive`);
const restoreTribute = (id) => callAPi.patch(`/admin/tribute/${id}/restore`);

const deleteTribute = (id) => callAPi.delete(`/admin/tribute/${id}`);

const tributeServices = {
  create,
  edit,
  get,
  getArchived,
  archiveTribute,
  restoreTribute,
  deleteTribute,
  getByID,
};

export default tributeServices;
